/**
 * Plan-step display helpers (TMMAPP-0025). Included counts and charged amounts come from the
 * quote; the trial-end civil date is the one allowed computed display value. No band-lookup
 * helpers and no SPA arithmetic on seat/connection totals.
 */
import type { PriceBook } from '@/api/entitlements';

/**
 * Trial-end civil date in the chosen zone (the one allowed computed display value). The result is
 * an ISO `YYYY-MM-DD` machine value rendered by `formatCivilDate`; `en-CA` only yields that shape.
 */
export function trialEndCivil(trialDays: number, timeZone: string, from = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(from);
  const y = Number(parts.find((p) => p.type === 'year')?.value);
  const m = Number(parts.find((p) => p.type === 'month')?.value);
  const d = Number(parts.find((p) => p.type === 'day')?.value);
  const local = new Date(y, m - 1, d + trialDays);
  const yy = local.getFullYear();
  const mm = String(local.getMonth() + 1).padStart(2, '0');
  const dd = String(local.getDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

/** Whether prices carry an annual offer (0051). Absent → hide the toggle. */
export function hasAnnualOffer(prices: PriceBook): boolean {
  return prices.annual != null;
}
